import type { ComponentProps } from 'react';
import { Row as AriaRow, composeRenderProps } from 'react-aria-components';
import clsx from 'clsx';

import styles from './Row.module.css';

type Props = ComponentProps<typeof AriaRow>;

export const Row = ({ children, ...props }: Props) => (
  <AriaRow {...props} className={composeRenderProps(props.className, (className) => clsx(className, styles.Row))}>
    {children}
  </AriaRow>
);
